<div class="page">
  <div class="header">
    <div class="header-text">
      <h1>Manage Tenants</h1>
      <div class="sub">Create, manage, and maintain customer tenants on the TOOB platform.</div>
    </div>

    <div class="header-actions">
      <mat-form-field appearance="outline" class="search">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="filterText" placeholder="Name, ID, plan" />
      </mat-form-field>

      <button mat-raised-button color="primary" (click)="openCreateDialog()">
        Create Tenant
      </button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="!loading && tenants.length === 0" class="empty">
    <div class="empty-title">No tenants yet</div>
    <div class="empty-sub">Create your first tenant to onboard a new customer.</div>
    <button mat-raised-button color="primary" (click)="openCreateDialog()">Create Tenant</button>
  </div>

  <div *ngIf="tenants.length > 0" class="table-wrap">
    <table mat-table [dataSource]="filteredTenants" class="mat-elevation-z0">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Tenant</th>
        <td mat-cell *matCellDef="let t">
          <div class="tenant-name">{{ t.name }}</div>
          <div class="tenant-id" (click)="copy(t.tenant_id)">{{ t.tenant_id }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="tenant_id">
        <th mat-header-cell *matHeaderCellDef>Tenant ID</th>
        <td mat-cell *matCellDef="let t">
          <button mat-button class="mono" (click)="copy(t.tenant_id)">Copy</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let t">
          <mat-chip [class]="statusClass(t)">{{ statusLabel(t) }}</mat-chip>
        </td>
      </ng-container>

      <ng-container matColumnDef="plan_type">
        <th mat-header-cell *matHeaderCellDef>Plan</th>
        <td mat-cell *matCellDef="let t">
          <span class="plan">{{ t.plan_type || 'free' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let t">
          <span class="muted">{{ t.created_at }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let t" class="actions">
          <button mat-button [matMenuTriggerFor]="menu">Actions</button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="rotateApiKey(t)">Rotate API key</button>
            <button mat-menu-item *ngIf="t.is_active" (click)="suspend(t)">Suspend</button>
            <button mat-menu-item *ngIf="!t.is_active" (click)="activate(t)">Activate</button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
